export default {
  text: '#111',
  primary: 'rgb(1, 110, 56)',
  secondary: 'rgb(246, 214, 83)',
  background: '#CEC08F',
  backgroundSecondary: 'rgb(204,190,141)',
  light: '#FFF',
  dark: '#000'
}
